import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { isPlatformScope, PLATFORM_FALLBACK_PATH } from '../../lib/platformGuard';

// Layout del área Platform (vista multi-tenant del backoffice). El guard de scope vive acá: tras
// `ensureLoaded`, si el user NO tiene scope PLATFORM rebota a /me/profile (mismo criterio que
// useAuth.isPlatform). Cubre todo /platform/* porque las rutas hijas anidan bajo este layout.
export const Route = createFileRoute('/_authenticated/_layout/platform')({
    beforeLoad: async ({ context }) => {
        const state = await context.auth.ensureLoaded();
        if (!isPlatformScope(state.roleAssignments)) {
            throw redirect({ to: PLATFORM_FALLBACK_PATH });
        }
    },
    component: () => <Outlet />,
});
